<template>
  <div
    class="d-flex justify-center"
    style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
  >
    <v-tabs
      v-model="categorySelected"
      background-color="transparent"
      centered
      :show-arrows="!this.$vuetify.breakpoint.smAndDown"
      icons-and-text
      class="menuBlur"
    >
      <v-tab
        v-for="(category, index) in categories"
        :key="`${category}-${index}`"
        class="d-flex flex-column"
        :class="$vuetify.breakpoint.mdAndDown && 'px-2'"
        @click="changeCategory(category.name)"
      >
        <v-icon size="22"> mdi-{{ category.icon }} </v-icon>
        <span
          :style="
            $vuetify.breakpoint.mdAndDown
              ? 'font-size: 10px; line-height: 15px;'
              : ''
          "
        >
          {{ category.name }}
        </span>
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "MenuCategories",
  props: ["categoryActive"],
  data: () => ({
    categorySelected: "",
  }),
  computed: {
    categories() {
      return [
        {
          name: "Home",
          icon: "dice-multiple",
        },
        ...(this.$store.state.operators.casino == 2
          ? [
              {
                name: "Spaceman",
                icon: "rocket-launch",
              },
            ]
          : []),
        {
          name: "Slots",
          icon: "slot-machine",
        },
        ...(this.$store.state.operators.casino == 2
          ? [
              {
                name: this.$t("liveCasino"),
                icon: "fruit-cherries",
              },
            ]
          : []),
        {
          name: this.$t("scratch"),
          icon: "clover",
        },
        {
          name: this.$t("tableGames"),
          icon: "cards-club",
        },
      ];
    },
    findIndexCategorySelected() {
      return this.categories.findIndex(
        (item) => item.name == this.$route.params.category
      );
    },
    hidePageCategories() {
      return (
        this.categorySelected == -1 ||
        (this.categorySelected == 0 && this.$route.name !== "casino")
      );
    },
  },
  methods: {
    changeCategory(category) {
      if (category === this.categoryActive) return;

      if (category === "Home") {
        if (this.$route.name === "casino" && !this.$route.query.gameSearch)
          return;
        this.$router.push({ path: "/casino/home" });
        return;
      }

      if (category === "Spaceman") {
        this.$emit("spacemanGame");
        return;
      }

      this.$emit("goGamesCategory", category);

      // Caso esteja em "Casino/home" e chamar pelo menu e não pelo "Ver todos"
      // redireciona para o "ListGamesCategories"
      this.$router.push({
        path: `/casino/listGamesCategories/${category}`,
        hash: "#scrollTop",
      });
    },
  },
  watch: {
    categorySelected() {
      if (this.categoryActive)
        this.categorySelected = this.findIndexCategorySelected;
      // Caso não tenha jogos filtrados redirecionar para home
      if (this.hidePageCategories) this.$router.push({ path: "/casino/home" });
    },
    // Mudar índice do "categorySelected" para categoria selecionada
    // após utilizar o botão voltar
    $route() {
      if (this.categoryActive)
        this.categorySelected = this.findIndexCategorySelected;
      // Caso não tenha jogos filtrados redirecionar para home
      if (this.hidePageCategories) this.$router.push({ path: "/casino/home" });
    },
  },
};
</script>
<style scoped>
.menuBlur {
  position: relative;
  z-index: 3;
  background: rgba(0, 0, 0, 0.49);
  backdrop-filter: blur(12.5px);
}
</style>
